import {
  ListItem,
  Paper,
  Stack,
  Box,
  Typography,
  Grid,
  Tooltip,
  IconButton,
} from "@mui/material";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { paginateArray } from "../helpers/paginateArray";
import { Edit, Share } from "@mui/icons-material";
import UserControl from "../Dialogs/UserControl";
dayjs.extend(relativeTime);

export default function ContactCard(props) {
  return (
    <div>
      {paginateArray(props.contacts, props.page, props.rowsPerPage).map(
        (obs, idx) => (
          <ListItem key={idx} style={{ padding: 0 }}>
            <Paper
              elevation={6}
              style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
            >
              <div style={{ padding: 20 }}>
                <Stack>
                  <Box
                    sx={{
                      width: "100%",
                      height: 10,
                      borderRadius: 1,
                      bgcolor: obs.Selected
                        ? "secondary.light"
                        : "primary.main",
                      // "&:hover": {
                      //   bgcolor: "primary.dark",
                      // },
                    }}
                  />
                  <Grid container spacing={0}>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="h6"
                          underline="hover"
                          // href={`/project/${props.projectId}/checklist-templates/${obs.id}/edit`}
                          color="secondary.main"
                        >{`Name: ${obs["Name"]}`}</Typography>
                      </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          color="secondary.light"
                        >{`Email:`}</Typography>
                        <Typography
                          style={{ marginLeft: 6 }}
                        >{`${obs.Email}`}</Typography>
                      </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          color="secondary.light"
                        >{`Phone:`}</Typography>
                        <Typography
                          style={{ marginLeft: 6 }}
                        >{`${obs["Phone Number"]}`}</Typography>
                      </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          color="secondary.light"
                        >{`Role:`}</Typography>
                        <Typography
                          style={{ marginLeft: 6 }}
                        >{`${obs["Role"]} - ${obs["Collaboration Status"]}`}</Typography>
                      </Stack>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <UserControl
                        isCreator={true}
                        user={obs["Created By"].toString()}
                        uid={obs?.uid}
                      />
                      {/* <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="secondary.light"
                        >{`Created By:`}</Typography>
                        <Typography style={{ marginLeft: 4 }} variant="caption">
                          {obs["Created By"]}
                        </Typography>
                      </Stack> */}
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="secondary.light"
                        >{`Created Date:`}</Typography>
                        <Typography style={{ marginLeft: 4 }} variant="caption">
                          {`${new Date(
                            obs["Created Date"].seconds * 1000,
                          ).toLocaleDateString()}
              
                 (${dayjs(
                   new Date(obs["Created Date"].seconds * 1000),
                 ).fromNow()})`}
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="secondary.light"
                        >{`Modified By:`}</Typography>
                        <Typography style={{ marginLeft: 4 }} variant="caption">
                          {obs["Modified By"]}
                        </Typography>
                      </Stack>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="secondary.light"
                        >{`Modified Date:`}</Typography>
                        <Typography style={{ marginLeft: 4 }} variant="caption">
                          {`${new Date(
                            obs["Modified Date"].seconds * 1000,
                          ).toLocaleDateString()}  (${dayjs(
                            new Date(obs["Modified Date"].seconds * 1000),
                          ).fromNow()})`}
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} />
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        style={{ paddingTop: 6 }}
                        direction="row"
                        spacing={1}
                        sx={{
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        <Tooltip title="Edit">
                          <IconButton
                            tabIndex={-1}
                            aria-label="Edit"
                            disabled={!props.allowUpdate}
                            size="large"
                            onClick={() => props.onEdit(obs.id)}
                            color={obs.Selected ? "primary" : "secondary.light"}
                          >
                            <Edit fontSize="inherit" />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Invite user to Project">
                          <IconButton
                            tabIndex={-1}
                            aria-label="Invite user to Project"
                            size="large"
                            onClick={() => props.onEmailContactClick(obs.Email)}
                            color={obs.Selected ? "primary" : "secondary.light"}
                          >
                            <Share fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </div>
            </Paper>
          </ListItem>
        ),
      )}
    </div>
  );
}
